var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"net-content"},[_c('img',{attrs:{"src":require("../../../static/img/network.png")}}),_vm._v(" "),_c('span',[_vm._v("链接不到网络")]),_vm._v(" "),_c('button',{staticClass:"net-btn",on:{"click":_vm.referNet}},[_vm._v("刷新网络")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ec02f82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/NoNetwork.vue
// module id = null
// module chunks = 